import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-confirmar-email',
  templateUrl: './confirmar-email.component.html',
  styleUrls: ['./confirmar-email.component.scss']
})
export class ConfirmarEmailComponent implements OnInit {
  public email = '';

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getParams();
  }

  getParams() {
    if (this.route.snapshot.params['email']) {
      this.email = this.route.snapshot.params['email'];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/components/confirmar-email/confirmar-email.component.ts